import axios from 'axios';

export default {
	namespaced: true,

	state: {
		entryId: 0,
		baseProducts: [],
		letterStyles: [],
		textArray: [],
		csrfToken: '',
		inputErrorArray: [false,false,false],
		selectedBaseProduct: null,
		selectedLetterStyle: null,
		selectedVariant: null,
		allProducts: [],
		loadingBase: true,
		loadingLetters: true,
	},

	mutations: {
		setEntryId(state, entryId) {
			state.entryId = entryId;
		},
		setBaseProducts(state, baseProducts) {
			state.baseProducts = baseProducts;
		},
		setLetterStyles(state, styles) {
			state.letterStyles = styles;
		},
		setTextArray(state, data) {
			state.textArray[data.index] = data.text;
		},
		setSelectedBaseProduct(state, baseProduct) {
			state.selectedBaseProduct = baseProduct;
		},
		setSelectedLetterStyle(state, style) {
			state.selectedLetterStyle = style;
		},
		setInputErrorArray(state, data) {
			state.inputErrorArray[data.index] = data.errorVal;
		},
		setSelectedVariant(state, variant) {
			state.selectedVariant = variant;
		},
		setCsrfToken(state, token){
			state.csrfToken = token;
		},
		setAllProducts(state, allProducts) {
			state.allProducts = allProducts;
		},
		setLoadingBase(state, loading) {
			state.loadingBase = loading;
		},
		setLoadingLetters(state, loading) {
			state.loadingLetter = loading;
		}
	},

	getters: {
		getEntryId(state) {
			return state.entryId;
		},
		getBaseProducts(state) {
			return state.baseProducts;
		},
		getSelectedBaseProduct(state) {
			return state.selectedBaseProduct;
		},
		getSelectedVariant(state) {
			return state.selectedVariant;
		},
		getLetterStyles(state) {
			return state.letterStyles;
		},
		getTextArray(state) {
			return state.textArray;
		},
		getInputErrorArray(state) {
			return state.inputErrorArray;
		},
		getSelectedLetterStyle(state) {
			return state.selectedLetterStyle;
		},
		getCsrfToken(state) {
			return state.csrfToken;
		},
		getAllProducts(state) {
			return state.allProducts;
		},
		getLoadingBase(state) {
			return state.loadingBase;
		},
		getLoadingLetters(state) {
			return state.loadingLetters;
		}
	},

	actions: {
		// Initializes the product by making the calls to the endpoints to get the data
		initProduct({ commit, dispatch }, { baseIds, baseType, letterIds }) {
			axios.get(`/store/products/customizable/base?id=${baseIds}&type=${baseType}`).then((response) => {
				commit('setBaseProducts', response.data);
				dispatch('selectBaseProduct', 0);
				dispatch('selectBaseVariant', 0);
				commit('setLoadingBase', false);
			});

			axios.get(`/store/products/letters/index?id=${letterIds}`)
				.then((response) => {
					commit('setLetterStyles', response.data);
					dispatch('selectLetterStyle', {
						index: 0,
						selected: false,
					});
					commit('setLoadingLetters', false);
				});
		},
		selectBaseProduct({ commit, state }, index) {
			// Filter out disabled variants
			const enabledVariants = state.baseProducts[index].variants.filter(variant => variant.enabled);
			state.baseProducts[index].variants = enabledVariants;
			commit('setSelectedBaseProduct', state.baseProducts[index]);
		},
		selectLetterStyle({ commit, state }, data) {
			if (data.selected) {
				const letterStyle = state.letterStyles.filter(
					(style) => style.id === data.selected.id
				);
				commit('setSelectedLetterStyle', letterStyle[0]);
			} else {
				commit(
					'setSelectedLetterStyle',
					state.letterStyles[data.index]
				);
			}
		},
		selectBaseVariant({ commit, state }, index) {
			commit(
				'setSelectedVariant',
				state.selectedBaseProduct.variants[index]
			);
		},
	},
};